import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../api-generated';
import { AuthService } from '../auth/auth.service';
import { NotificationService } from '../notification/notification.service';
import { ProgramPage } from 'app/program/program.page';



@Injectable({
  providedIn: 'root'
})
export class AuthRouteGuardService  {

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private router: Router,
  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.getSessionUser(true)
    .pipe(
      map((user: User) => {
        if (user) return true;

        // Repeated round-trips have come back unauthenticated, so another redirect
        // would just loop. Cancelling navigation leaves nothing on screen, so raise
        // the dialog here rather than assume the round-trip that set reauthBouncing
        // is still around to raise it (a refresh outlives it).
        if (this.authService.reauthBouncing) {
          this.authService.notifySessionExpired();

          return false;
        }

        this.authService.discovery();

        return false;
      }),
      catchError((error: any) => {
        this.notificationService.apiError(error);

        return of(this.router.createUrlTree(['/']));
      })
    );
  }
}
